import Skeleton from "@components/scheduling/analytics/Skeleton";

/** The tile's colour, by what the figure means. Text stays on text tokens. */
const TONES = {
  booked: { value: "text-green-700", bar: "bg-green-600" },
  voicemail: { value: "text-amber-700", bar: "bg-amber-600" },
  neutral: { value: "text-gray-900", bar: "bg-slate-400" },
};

/**
 * One headline figure: the label, the overall value large, today's figure
 * beneath it and a one-line caption that says what the number is made of.
 */
export default function StatTile({ label, value, sub, caption, tone = "neutral", loading }) {
  const colours = TONES[tone] || TONES.neutral;
  if (loading) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4" aria-busy="true">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="mt-3 h-9 w-24" />
        <Skeleton className="mt-3 h-3 w-32" />
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-center gap-2">
        <span className={`h-2 w-2 rounded-full ${colours.bar}`} aria-hidden="true" />
        <p className="text-sm font-medium text-gray-600">{label}</p>
      </div>
      <p className={`mt-2 text-3xl font-semibold ${colours.value}`}>{value}</p>
      <p className="mt-1 min-h-[1.25rem] text-sm text-gray-600">{sub}</p>
      {caption && <p className="mt-1 text-xs text-gray-500">{caption}</p>}
    </div>
  );
}
